import { render, staticRenderFns } from "./SshAccessView.vue?vue&type=template&id=35670920&"
import script from "./SshAccessView.vue?vue&type=script&lang=js&"
export * from "./SshAccessView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35670920')) {
      api.createRecord('35670920', component.options)
    } else {
      api.reload('35670920', component.options)
    }
    module.hot.accept("./SshAccessView.vue?vue&type=template&id=35670920&", function () {
      api.rerender('35670920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/security/SshAccessView.vue"
export default component.exports